// extracted by mini-css-extract-plugin
export default {"layout":"TopicTabs_layout__mQSRa","tabs":"TopicTabs_tabs__4h6FK","tab":"TopicTabs_tab__P8dni","active":"TopicTabs_active__AzWlo","panel":"TopicTabs_panel__itng+"};